/**
 * Persisted MedMic disconnect latch + last validated account identity.
 * Namespaced for MedMic only — never uses Enterprise Zustand.
 */

const LATCH_KEY = "medmic_disconnect_latch_v1";

/**
 * @typedef {object} MedMicDisconnectLatch
 * @property {boolean} disconnected
 * @property {string} sessionId
 * @property {number} generation
 * @property {number} epoch
 * @property {string | null} [lastUserEmail]
 * @property {string | null} [lastAccountIdentifier] homeAccountId
 * @property {string | null} [lastLocalAccountId]
 */

/** @returns {MedMicDisconnectLatch | null} */
export function readMedMicDisconnectLatch() {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(LATCH_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      disconnected: Boolean(parsed.disconnected),
      sessionId:
        typeof parsed.sessionId === "string" ? parsed.sessionId : "",
      generation:
        typeof parsed.generation === "number" ? parsed.generation : 0,
      epoch: typeof parsed.epoch === "number" ? parsed.epoch : 0,
      lastUserEmail:
        typeof parsed.lastUserEmail === "string" ? parsed.lastUserEmail : null,
      lastAccountIdentifier:
        typeof parsed.lastAccountIdentifier === "string"
          ? parsed.lastAccountIdentifier
          : null,
      lastLocalAccountId:
        typeof parsed.lastLocalAccountId === "string"
          ? parsed.lastLocalAccountId
          : null,
    };
  } catch {
    return null;
  }
}

/** @param {MedMicDisconnectLatch} latch */
export function writeMedMicDisconnectLatch(latch) {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(LATCH_KEY, JSON.stringify(latch));
  } catch {
    /* ignore */
  }
}

export function clearMedMicDisconnectLatchForTests() {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.removeItem(LATCH_KEY);
  } catch {
    /* ignore */
  }
}

export { LATCH_KEY as MEDMIC_DISCONNECT_LATCH_KEY };
